import axios from "axios";

import authService from "./AuthService";

const axiosInstance = axios.create({
  baseURL: "/api/", // Set your common base URL here
  withCredentials: true,
});

/* Interceptor to add token to every request */
axiosInstance.interceptors.request.use(
  async (config) => {
    const token = authService.getToken(); // Get token from AuthService
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

/* Auto refreshes the token if expired */
axiosInstance.interceptors.response.use(
  (response) => response,
  async function (error) {
    console.log("response", error.response);
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const AuthResponse = await authService.refresh();
        error.response.config.headers.Authorization = `Bearer ${AuthResponse.token}`;
        return axiosInstance(error.response.config);
      } catch (error) {
        window.location.href = "/login";
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
